import { Avatar as MuiAvatar, avatarClasses } from "@mui/material";
import React from "react";

import palette from "src/theme/palette";

import { getStringInitials, stringToColor } from "@utils";

const Avatar = ({ variant, name, size, fontSize, src, sx = {}, ...rest }) => (
  <MuiAvatar
    variant={variant}
    src={src}
    alt={src ? name : undefined}
    sx={{
      width: size,
      height: size,
      fontSize,
      bgcolor: src ? palette.system[0] : stringToColor(name),
      ...(src && { padding: "2px", [`& .${avatarClasses.img}`]: { objectFit: "contain" } }),
      ...sx
    }}
    {...rest}
  >
    {getStringInitials(name, 2)}
  </MuiAvatar>
);

export default Avatar;
